import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";

import { METERS_CONFIG, METERS_PHRASE } from "./config";
import { editMeter } from "redux/actions/buildings/meters/metersAction";
import RegularButton from "components/CustomButtons/Button";

const style = {
  color: "#004F9F",
  fontSize: 20,
  marginRight: 10,
  cursor: "pointer"
};

export const columns = [
  {
    Header: () => <span>{METERS_CONFIG.serialNumber.label}</span>,
    accessor: METERS_CONFIG.serialNumber.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.serialNumber.key]
        ? row[METERS_CONFIG.serialNumber.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.brand.label}</span>,
    accessor: METERS_CONFIG.brand.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.brand.key]
        ? row[METERS_CONFIG.brand.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.model.label}</span>,
    accessor: METERS_CONFIG.model.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.model.key]
        ? row[METERS_CONFIG.model.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>{METERS_CONFIG.installationDate.label}</span>,
    accessor: METERS_CONFIG.installationDate.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.installationDate.key]
        ? row[METERS_CONFIG.installationDate.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.releaseDate.label}</span>,
    accessor: METERS_CONFIG.releaseDate.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.releaseDate.key]
        ? row[METERS_CONFIG.releaseDate.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.lastReading.label}</span>,
    accessor: METERS_CONFIG.lastReading.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.lastReading.key]
        ? row[METERS_CONFIG.lastReading.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.capture.label}</span>,
    accessor: METERS_CONFIG.capture.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.capture.key]
        ? row[METERS_CONFIG.capture.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{METERS_CONFIG.status.label}</span>,
    accessor: METERS_CONFIG.status.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[METERS_CONFIG.status.key]
        ? row[METERS_CONFIG.status.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editMeter(original.id));
      };
      return (
        <ColumnContainer>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip={METERS_PHRASE.modal.actions.edit}
            onClick={openEdit}
            size="sm"
          >
            <EditIcon style={style} />
          </RegularButton>
        </ColumnContainer>
      );
    },
  },
];
